/** Shared video quality ladder (height in px) — Plyr `size` attribute */
export const VIDEO_QUALITY_LADDER = [
  4320, // 8K
  2160, // 4K
  1440,
  1080,
  720,
  480,
  360,
] as const

export type VideoQualityHeight = (typeof VIDEO_QUALITY_LADDER)[number]

export const VIDEO_QUALITY_LABELS: Record<number, string> = {
  4320: '8K',
  2160: '4K',
  1440: '1440p',
  1080: '1080p',
  720: '720p',
  480: '480p',
  360: '360p',
}

export function normalizeVideoStoragePath(path: string): string {
  return path.replace(/^\/+/, '').replace(/^storage\//, '')
}

/** Strip `_q720` (etc.) before extension → master path */
export function getMasterVideoPath(path: string): string {
  return normalizeVideoStoragePath(path).replace(/_q\d+(?=\.[^.]+$)/i, '')
}

/** `video/…/file.mp4` + 720 → `video/…/file_q720.mp4` */
export function buildVideoQualityKey(masterPath: string, quality: number): string {
  const master = getMasterVideoPath(masterPath)
  return master.replace(/(\.[^.]+)$/, `_q${quality}$1`)
}

export function snapToQualityLadder(height: number): number {
  for (const q of VIDEO_QUALITY_LADDER) {
    if (height >= q - 48) return q
  }
  return 360
}
